<template>
    <div
        id="app"
        class="app sidebar-mini rtl"
        v-bind:class="{ 'sidenav-toggled': sidenavCollapsed }"
    >
        <em-header :baseApiUrl="baseApiUrl" :userId="userId" v-if="showHeader">
            <template #logo>
                <img src="@/assets/images/SE_Logo_White_RGB.png"
                     class="sidebar-logo"
                />
                <h4 v-if="currentEnv === 'test'" class="ml-2 text-white font-weight-bold m-tb-auto">
                    测试环境
                </h4>
            </template>
        </em-header>

        <em-sidebar></em-sidebar>

        <div style="z-index: 1039;position: fixed;right: 140px;width: 500px;top: 51px;">
            <b-alert
                dismissible
                fade
                :show="userAlertWarningVisible"
                @dismissed="resetStateAlertWarning"
                variant="warning">
                <i class="fa fa-exclamation-triangle"></i>
                {{ $t(userAlertWarningStr) }}
            </b-alert>

            <b-alert
                dismissible
                :show="dismissCountDownSuccess"
                :hidden="userAlertSuccessVisible"
                @dismissed="resetStateAlertSuccess"
                fade
                @dismiss-count-down="countDownChanged"
                variant="success">
                <b-container fluid>
                    <b-row>
                        <b-col>
                            <i class="fa fa-check"></i>
                            {{ userAlertSuccessStr }}
                        </b-col>
                        <b-col cols="2" align-self="end">
                            <span style="font-size: 8px;">
                                Dismissing in {{ dismissCountDownSuccess }}
                            </span>
                        </b-col>
                    </b-row>
                    <b-progress
                        variant="warning"
                        :max="5"
                        :value="dismissCountDownSuccess"
                        height="2px"
                    ></b-progress>
                </b-container>
            </b-alert>

            <b-alert
                :show="userAlertDangerVisible"
                dismissible
                @dismissed="resetStateAlertDanger"
                fade
                variant="danger">
                <i class="fas fa-ban"></i>
                {{ $t(userAlertDangerStr) }}
            </b-alert>
        </div>

        <b-modal
            :visible="showAlertModal"
            @hide="resetState"
            :title="$t(modalTitle)"
            hide-footer
            size="lg"
            scrollable
            :header-bg-variant="headerBgVariant"
            ref="exceptionModal">
            <div role="tablist">
                <div class="d-block text-center">
                    <h3 align="center" style="color:#6C6C6C">{{ $t(modalHeader) }}</h3>
                </div>
                <div class="mb-1">
                    <i class="fa fa-caret-right mr-1" v-if="!showStackTraceCollapse"></i>
                    <i
                        class="fa fa-caret-down mr-1"
                        v-else-if="showStackTraceCollapse"
                    ></i>

                    <b-link
                        href="#"
                        @click="showStackTraceCollapse = !showStackTraceCollapse"
                        :class="showStackTraceCollapse ? 'collapsed' : null"
                        aria-controls="accordion1"
                        :aria-expanded="showStackTraceCollapse ? 'true' : 'false'"
                    >
            <span v-if="!showStackTraceCollapse">
              {{ $t("lbl.show.details") }}
            </span>
                        <span v-if="showStackTraceCollapse">
              {{ $t("lbl.hide.details") }}
            </span>
                    </b-link>
                    <b-collapse
                        id="accordion1"
                        accordion="my-accordion"
                        role="tabpanel"
                        v-model="showStackTraceCollapse">
                        <template #default>
                            <div style="white-space: pre-wrap;">
                                {{ modalContent }}
                            </div>
                        </template>
                    </b-collapse>
                </div>
                <div slot="modal-footer" class="float-right">
                    <!-- <b-button variant="outline-danger" v-on:click="printError">Print error</b-button> -->
                    <b-button
                        variant="outline-danger"
                        class="ml-1"
                        v-on:click="sendEmail">
                        {{ $t("lbl.basic.sendEmail") }}
                    </b-button>
                    <b-button variant="secondary" class="ml-1" v-on:click="hideModal">
                        {{ $t("lbl.basic.close") }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <mmf-loading-panel :isLoading="showLoadingModal"/>
        <mmf-confirm-modal v-if="showConfirmModal"/>
        <mmf-entity-viewer-modal
            v-if="entityModal.isVisible"
            :isVisible="entityModal.isVisible"
            :entity="entityModal.entity"
            :object="entityModal.entityObject"/>

        <!--        <router-view></router-view>-->
    </div>
</template>

<script>
// import MmfHeader from "@/components/MmfHeader";
import EmHeader from "@/components/em/EmHeader";
import EmSidebar from "@/components/em/EmSidebar3Level";
// import EmSidebar from "@/components/em/EmSidebar";
import MmfLoadingPanel from "@/components/MmfLoadingPanel";
import MmfConfirmModal from "@/components/MmfConfirmModal";

import {mapActions, mapState} from "vuex";
import MmfEntityViewerModal from "./components/MmfEntityViewerModal";

export default {
    name: "app",
    components: {
        EmHeader,
        EmSidebar,
        MmfLoadingPanel,
        MmfConfirmModal,
        MmfEntityViewerModal
    },
    data: function () {
        return {
            baseApiUrl: process.env.VUE_APP_ADM_API_URL,
            userId: 1,

            showStackTraceCollapse: true,

            dismissSecs: 5,
            dismissCountDown: 5
        };
    },
    computed: {
        ...mapState({
            showAlertModal: state => state.base.showAlertModal,
            modalTitle: state => state.base.modalTitle,
            modalHeader: state => state.base.modalHeader,
            modalContent: state => state.base.modalContent,
            headerBgVariant: state => state.base.headerBgVariant,

            showLoadingModal: state => state.base.showLoadingModal,
            showConfirmModal: state => state.confirmationModal.isVisible,
            entityModal: state => state.entityModal,

            userAlertWarningStr: state => state.base.userAlertWarningStr,
            userAlertWarningVisible: state => state.base.userAlertWarningVisible,
            userAlertSuccessStr: state => state.base.userAlertSuccessStr,
            userAlertSuccessVisible: state => state.base.userAlertSuccessVisible,
            //先屏蔽，提示没有setter  - 2020-9-10
            dismissCountDownSuccess: state => state.base.dismissCountDownSuccess,
            userAlertDangerStr: state => state.base.userAlertDangerStr,
            userAlertDangerVisible: state => state.base.userAlertDangerVisible,

            showHeader: state => state.base.showHeader,
            showSidebar: state => state.base.showSidebar,
            sidenavCollapsed: state => state.base.showCollapse,
        }),
        currentEnv() {
            return process.env.NODE_ENV;
        },
    },
    methods: {
        resetState: function () {
            this.$store.commit("base/setShowAlertModal", false, {root: true});
        },
        resetStateAlertWarning: function () {
            this.$store.commit("base/setUserAlertWarningVisible", false, {
                root: true
            });
        },
        resetStateAlertDanger: function () {
            this.$store.commit("base/setUserAlertDangerVisible", false, {
                root: true
            });
        },
        resetStateAlertSuccess: function () {
            this.$store.commit("base/setUserAlertSuccessVisible", false, {
                root: true
            });
        },
        ...mapActions("base", ["showAlertModalMethod"]),
        printError() {
            var mywindow = window.open("", "my div", "height=400,width=600");
            mywindow.document.write(
                "<html><head><title>" + this.$store.state.base.modalHeader + "</title>"
            );
            mywindow.document.write("</head><body >");
            mywindow.document.write(this.$store.state.base.modalContent);
            mywindow.document.write("</body></html>");
            mywindow.print();
            mywindow.close();
        },
        sendEmail() {
            var user = {
                id: 1,
                login: "mmf-user",
                email: "user@siemens.mmf.com"
            };

            var email = user.email ? user.email : "not-replay@siemens.mmf.com";

            var mywindow = window.open(
                "mailto:" +
                email +
                "?subject=" +
                this.$store.state.base.modalHeader +
                "&body=" +
                this.$store.state.base.modalHeader
            );
            mywindow.document.write("<script>window.close()<//script>");
        },

        hideModal() {
            this.$refs.exceptionModal.hide();
        },

        countDownChanged(dismissCountDown) {
            this.$store.commit("base/setDismissCountDownSuccess", dismissCountDown);
        },

        mergeI18nFromDict() {
            this.$store.dispatch('dictionaryEnumStore/getDictOriginal', 'i18n_message')
                .then(res => {
                    let all = {};
                    for (let item of res) {
                        if (item.name) {
                            let index = item.name.indexOf(":");
                            if (index >= 0) {
                                let lang = item.name.substring(0, index);
                                let key = item.name.substring(index + 1);
                                if (!(lang in all)) {
                                    all[lang] = {};
                                }
                                all[lang][key] = item.value;
                            }
                        }
                    }
                    Object.keys(all).forEach((lang) => this.$i18n.add(lang, all[lang]));
                });
        },
    },
    mounted() {
        this.mergeI18nFromDict();
        //store current user
        this.$store.dispatch('userStore/getCurrentUser');
    }
};
</script>
